import { SiteConfig } from '~/config'

export function isUrlInternal(url: string): boolean {
	if (!url || url.indexOf('http') === -1) return true

	return url.startsWith(SiteConfig.siteInfo.rootUrl)
}
